import React, { useEffect, useState } from 'react';

import { block } from 'bem-cn';
import { ImmutableMapItem } from 'type';

import MiniTag from '../MiniTag';

import './miniTags.scss';

const b = block('minitags');

const MARGIN = 2;
const REMAINING_TAGS_MINITAG_WIDTH = 26;

type MiniTagsPropsType = {
  card: {
    id: string;
    title?: string;
  } & ImmutableMapItem;
  parentWidth: number;
};
const MiniTags = ({ card, parentWidth }: MiniTagsPropsType) => {
  const [showTags, setShowTags] = useState(false);
  const [
    tagsToDisplay,
    setTags,
  ] = useState<any /* TODO nonsense, array and also size */>([]);

  const tagWidthsArray: { title: string; width: number }[] = [];
  let filledSpace = 0;

  const formArrayToDisplay = () => {
    if (parentWidth) {
      return card.get('tags').filter((el: any) => {
        const tag = tagWidthsArray.find((tag) => el.get('title') === tag.title);
        const itemWidth = MARGIN * 2 + (tag?.width || 0);
        filledSpace += itemWidth;
        const isToDisplay =
          filledSpace < parentWidth - REMAINING_TAGS_MINITAG_WIDTH;
        return isToDisplay;
      });
    }
  };

  useEffect(() => {
    if (!showTags && parentWidth) {
      setTags(formArrayToDisplay());
      setShowTags(true);
    }
  }, [parentWidth]);

  // const getMinitagWidth = (tagWidth: number, tagName: string) => {
  //   tagWidthsArray.push({ title: tagName, width: tagWidth });
  // };

  return (
    <div className={b()}>
      {showTags &&
        tagsToDisplay.map((tag: any) => (
          <MiniTag tag={tag.get('title')} key={tag.get('title')} />
        ))}
      {showTags && card.get('tags').size - tagsToDisplay.size > 0 && (
        <MiniTag
          tag={`+${card.get('tags').size - tagsToDisplay.size}`}
          key={card.get('tags').size - tagsToDisplay.size}
        />
      )}
      {/* {card.get('tags').map((tag: any) => (
        <MiniTag
          tag={tag.get('title')}
          key={tag.get('title')}
          onWidth={getMinitagWidth}
          processFlag
          hidden
        />
      ))} */}
    </div>
  );
};

export default MiniTags;
